'use client';

import { getOpticalProcedureTitle } from './normalize';
import { useOpticalProcedureCopywriting } from './CopywritingProvider';
import type { OpticalProcedureTitleKey } from './types';

export function useOpticalProcedureTitle(key: OpticalProcedureTitleKey, fallback: string) {
  const copywriting = useOpticalProcedureCopywriting();
  return getOpticalProcedureTitle(copywriting, key, fallback);
}
